module.exports = "/assets/data/236dc6594328a11392a952637f9bf4e4-LS28.data.json";